"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSafari = isSafari;
exports.isAndroidDevice = isAndroidDevice;
exports.isIosDevice = isIosDevice;
exports.isMobileDevice = isMobileDevice;
exports.isFirefox = isFirefox;
exports.isChrome = isChrome;
exports.supportsModernChrome = supportsModernChrome;
exports.isEdge = isEdge;
exports.isIE = isIE;
exports.oldWindowsChrome = oldWindowsChrome;
exports.isWindows = isWindows;
exports.chromeWithoutMp4Support = chromeWithoutMp4Support;
exports.safariWithoutMp4Support = safariWithoutMp4Support;
exports.safariLessThan14 = safariLessThan14;
exports.hasPermissionsChangeSupport = hasPermissionsChangeSupport;
const tslib_1 = require("tslib");
const bowser_1 = tslib_1.__importDefault(require("bowser"));
const semver_1 = tslib_1.__importDefault(require("semver"));
const feature_1 = require("../../../api/adapter/features/feature");
/**
 * win chrome 51 and below have a bug in mse causing black screens on bitrate switches
 * @returns boolean
 */
function oldWindowsChrome(device) {
    var _a;
    if (!device.isWindows || !device.isChrome) {
        return false;
    }
    if (device.isImplements(feature_1.Feature.USER_AGENT_DATA) && ((_a = device.highEntropyValues) === null || _a === void 0 ? void 0 : _a.fullVersionList) != null) {
        const isChromeBrowser = (item) => ["Google Chrome"].includes(item.brand);
        const chrome = device.highEntropyValues.fullVersionList.find(isChromeBrowser);
        const coerced = semver_1.default.coerce(chrome === null || chrome === void 0 ? void 0 : chrome.version);
        if (coerced) {
            return semver_1.default.lt(coerced, "52.0.0");
        }
    }
    if (device.appVersion != null) {
        const coerced = semver_1.default.coerce(device.appVersion);
        if (coerced) {
            return semver_1.default.lt(coerced, "52.0.0");
        }
    }
    return false;
}
/**
 * Only supported on Chrome >= 14.3
 * @returns boolean
 */
function supportsModernChrome(device) {
    var _a;
    if (device.isImplements(feature_1.Feature.USER_AGENT_DATA) && ((_a = device.highEntropyValues) === null || _a === void 0 ? void 0 : _a.fullVersionList) != null) {
        const isChromeBrowser = (item) => ["Google Chrome"].includes(item.brand);
        const chrome = device.highEntropyValues.fullVersionList.find(isChromeBrowser);
        const coerced = semver_1.default.coerce(chrome === null || chrome === void 0 ? void 0 : chrome.version);
        if (coerced) {
            return semver_1.default.gte(coerced, "14.3.0");
        }
    }
    if (device.appVersion != null && device.isChrome) {
        const coerced = semver_1.default.coerce(device.appVersion);
        if (coerced) {
            return semver_1.default.gte(coerced, "14.3.0");
        }
    }
    return false;
}
/**
 * Only supported on Safari >= 14. Safari doesn't support UAD as of 2/2024
 * @returns boolean
 */
function safariLessThan14(device) {
    if (device.appVersion != null && device.isSafari) {
        const coerced = semver_1.default.coerce(device.appVersion);
        if (coerced) {
            return semver_1.default.lt(coerced, "14.0.0");
        }
    }
    return false;
}
/**
 * Only supported on Safari >= 16.4. Safari doesn't support UAD as of 2/2024
 * @returns boolean
 */
function hasPermissionsChangeSupport(device) {
    if (device.isIE) {
        return false;
    }
    if (device.appVersion != null && device.isSafari) {
        const coerced = semver_1.default.coerce(device.appVersion);
        if (coerced) {
            return semver_1.default.gte(coerced, "16.4.0");
        }
    }
    if (device.appVersion != null && device.isEdge) {
        const coerced = semver_1.default.coerce(device.appVersion);
        if (coerced) {
            return semver_1.default.gte(coerced, "79.0.0");
        }
    }
    if (device.appVersion != null && device.isChrome) {
        const coerced = semver_1.default.coerce(device.appVersion);
        if (coerced) {
            return semver_1.default.gte(coerced, "43.0.0");
        }
    }
    return true;
}
/**
 * chrome 49 and below don't supprot meow
 * @returns boolean
 */
function chromeWithoutMp4Support(device) {
    var _a;
    if (!device.isChrome)
        return false;
    if (device.isImplements(feature_1.Feature.USER_AGENT_DATA) && ((_a = device.highEntropyValues) === null || _a === void 0 ? void 0 : _a.fullVersionList) != null) {
        const isChromeBrowser = (item) => ["Google Chrome"].includes(item.brand);
        const chrome = device.highEntropyValues.fullVersionList.find(isChromeBrowser);
        const coerced = semver_1.default.coerce(chrome === null || chrome === void 0 ? void 0 : chrome.version);
        if (coerced) {
            return semver_1.default.lte(coerced, "49.0.0");
        }
    }
    if (device.appVersion != null) {
        const coerced = semver_1.default.coerce(device.appVersion);
        if (coerced) {
            return semver_1.default.lte(coerced, "49.0.0");
        }
    }
    return false;
}
/**
 * Safari less than 10 doesn't support meow
 * @returns boolean
 */
function safariWithoutMp4Support(device) {
    if (!device.isSafari)
        return false;
    if (device.appVersion != null) {
        const coerced = semver_1.default.coerce(device.appVersion);
        if (coerced) {
            return semver_1.default.lt(coerced, "10.0.0");
        }
    }
    return false;
}
function isIosDevice(device) {
    const iosDeviceArray = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod", "iOS"];
    if (device.platform != null) {
        if ((device.platform === "macOS" || device.platform === "MacIntel") && device.isImplements(feature_1.Feature.MULTI_TOUCH)) {
            /* iPad iOS 13+ */
            return true;
        }
        return iosDeviceArray.includes(device.platform);
    }
    return false;
}
function isAndroidDevice(device) {
    let android = false;
    if (device.userAgent != null) {
        android = /Android/.test(device.userAgent);
    }
    return android;
}
function isIE(device) {
    return device.browserInfo.browserName === "Internet Explorer";
}
function isWindows(device) {
    return device.browserInfo.platform === "Windows";
}
function isMobileDevice(device) {
    // Default to UserAgentData
    if (device.isImplements(feature_1.Feature.USER_AGENT_DATA) && device.userAgentData != null) {
        return device.userAgentData.mobile;
    }
    if (device.isImplements(feature_1.Feature.MULTI_TOUCH)) {
        return true;
    }
    if (device.userAgent != null) {
        const browser = bowser_1.default.getParser(device.userAgent).getPlatform().type;
        if (browser != null) {
            return browser === "mobile";
        }
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(device.userAgent)) {
            return true;
        }
    }
    return false;
}
/**
 *
 * Safari doesn't support userAgentData at this time
 */
function isSafari(device) {
    return device.browserInfo.browserName === "Safari";
}
/**
 *
 * Firefox doesn't support userAgentData at this time
 */
function isFirefox(device) {
    return device.browserInfo.browserName === "Firefox";
}
function isChrome(device) {
    var _a, _b;
    if (device.isImplements(feature_1.Feature.USER_AGENT_DATA) && ((_a = device.userAgentData) === null || _a === void 0 ? void 0 : _a.brands) != null) {
        const isChromeBrowser = (item) => ["Google Chrome"].includes(item.brand);
        return (_b = device.userAgentData) === null || _b === void 0 ? void 0 : _b.brands.some(isChromeBrowser);
    }
    if (device.browserInfo.browserName != null) {
        return device.browserInfo.browserName === "Chrome";
    }
    return false;
}
function isEdge(device) {
    var _a, _b;
    if (device.isImplements(feature_1.Feature.USER_AGENT_DATA) && ((_a = device.userAgentData) === null || _a === void 0 ? void 0 : _a.brands) != null) {
        const isEdgeBrowser = (item) => ["Edge"].includes(item.brand);
        return (_b = device.userAgentData) === null || _b === void 0 ? void 0 : _b.brands.some(isEdgeBrowser);
    }
    if (device.browserInfo.browserName != null) {
        return device.browserInfo.browserName === "Microsoft Edge" || device.browserInfo.browserName === "Edge";
    }
    return false;
}
//# sourceMappingURL=user-agent.js.map